import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { IEnv } from 'kts-platform-frame/redux/ReduxState';
// import JSString from 'kts-scaffold-framework/utils/kit/JSString';
// import { Urls } from 'kts-platform-frame/entry/constant';
import { loginUrl } from 'kts-platform-frame/entry/configUtils';
import { Input, Button, Form, Dropdown, Menu } from 'antd';
import Icon from 'kts-platform-frame/display/components/Icon';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onSubmit: (params:any)=>void;
    onCancel: () =>void;
    companyName?: string;
}

/** 熟人用户名密码面板 */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class UIPanel extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    render() {
        const   name = this.modulesState.clientAppName || '公司';
        return (
            <div className={css.body} >
                <div className={css.toper}>
                    <div className={css.title}>{name}授权</div>
                    <div><img src={require('./img.logo.svg')} height="24" alt=""/></div>
                    <div className={css.subtitle}>迅联云申请获得以下权限:</div>
                    <div className={css.info}><div className={css.spot}></div>获得你的公开信息（公司名称等）</div>
                    <div className={css.subtitle} style={{margin: '50px 0'}}>检测到您已注册过迅联云账号，请输入迅联云账号密码进行绑定（仅首次需要）</div>
                </div>
                <div className={css.content}>
                    <div className={css.panel}>
                        <this.renderOrdinary />
                    </div>
                </div>
                <this.renderFooter />
            </div>
        );
    }

    /** 登录授权页 */
    private renderOrdinary = () => {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const   menu = (
            <Menu className="kts-menus">
                <Menu.Item onClick={()=>this.resetPass('phone')}>通过手机号码重置</Menu.Item>
                <Menu.Item onClick={()=>this.resetPass('email')}>通过邮箱重置</Menu.Item>
            </Menu>
        );
        return (
            <Form className={`${css.ordinary} clear`}>
                <Form.Item>
                    {getFieldDecorator('username', {
                        rules: [{ required: true, message: '用户名不能为空' }],
                    })(
                        <Input
                            placeholder="用户名"
                            prefix={<Icon color="#000" width={14} height={14} src={require('./img.user.svg')} />}
                        />
                    )}
                </Form.Item>

                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: '密码不能为空' }],
                    })(
                        <Input
                            type="password"
                            placeholder="密码"
                            prefix={<Icon color="#000" width={14} height={14} src={require('./img.password.svg')} />}
                        />
                    )}
                </Form.Item>

                <Button onClick={this.onClickLanding} >绑定</Button>
                <Dropdown overlay={menu} placement="bottomCenter"><a  className={css.forget}>忘记密码?</a></Dropdown>
            </Form>
        );
    }

    /** 底部 */
    private renderFooter = () => {
        return (
            <div className={css.footer} >
                <p>
                    <Icon color="#000" width={18} height={18} src={require('./img.phone.svg')} />
                    服务热线：400-836-3566 | 
                    <Icon color="#000" width={18} height={18} src={require('./img.mail.svg')} />
                    <a href="mailto:support@kingxunlian.com">support@kingxunlian.com</a>
                </p>
                <p>迅联集团2018 粤ICP备17007740号-1</p>
            </div>
        );
    }

    /** 点击了登录 */
    private onClickLanding = (): void => {
        const { form } = this.props;
        form.validateFields(async (er: any, values: any) => {
            if (er) {
                return;
            } 
            this.props.onSubmit(values);
        });
    }
    /** 重置密码 */
    private resetPass = (type: string): void => {
        const url = `${loginUrl()}/login/setpassword.html?way=${type}`;
        window.open(url);
    }
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/LoginThird/UI.Panel/index.tsx